const constants = {
  ROUTE_MAPPING_EVENTS: {
    DRAWING_IN_PROGRESS: "drawingInProgress",
    DRAWING_CREATED_ON_MAP: "handleCreatedDrawingOnMap",
    DRAWING_SELECTED_ON_MAP: "drawingSelectedOnMap",
    DRAWING_DELETED: "drawingDeleted",
    DRAWING_UPDATED: "drawingUpdated",
    DRAWING_SELECTED_ON_SIDE_PANEL: "drawingSelectedOnSidePanel",
    CLOSE_FORM: "closeForm",
  },
};

export default constants;
